import SEO from "@/components/SEO";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TransformationSection from "@/components/landing/TransformationSection";
import HowItWorksSection from "@/components/landing/HowItWorksSection";
import FeatureBlocksSection from "@/components/landing/FeatureBlocksSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import PricingSection from "@/components/PricingSection";
import ComparisonSection from "@/components/landing/ComparisonSection";
import GuaranteeSection from "@/components/landing/GuaranteeSection";
import FAQSection from "@/components/landing/FAQSection";
import FinalCTASection from "@/components/FinalCTASection";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { LogIn, User } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

const Index = () => {
  const { user, loading } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <SEO 
        title="MarketPro Tools - Ferramentas de Marketing Digital"
        description="Plataforma completa de marketing digital e gestão empresarial. Acesse mais de 12 ferramentas especializadas para alavancar seu negócio."
        keywords="ferramentas marketing digital, gestão empresarial, planilhas marketing, automação, dashboard"
      />
      
      {/* Auth Button */}
      {!loading && (
        <div className="fixed top-4 right-4 z-50">
          {user ? (
            <Link to="/dashboard">
              <Button variant="default" size="sm">
                <User className="w-4 h-4 mr-2" />
                Dashboard
              </Button>
            </Link>
          ) : (
            <Link to="/auth">
              <Button variant="cta" size="sm">
                <LogIn className="w-4 h-4 mr-2" />
                Entrar
              </Button>
            </Link>
          )}
        </div>
      )}

      <Header />
      <main>
        <Hero />
        <TransformationSection />
        <HowItWorksSection />
        <FeatureBlocksSection />
        <TestimonialsSection />
        <PricingSection />
        <ComparisonSection />
        <GuaranteeSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
